import React, { useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { tryToCategorizePayableInvoices, tryToCategorizeReceivableInvoices } from '../../../../store/brokers/partner/invoices/invoicesSlice';
import Button from '../../../../shared/button';
import Error from '../../../../shared/error';
import Modal from '../../../../shared/modal';
import Datepicker from '../../../../shared/datepicker';


interface ICategorizeModal {
    openModal: boolean;
    type: string;
    username: string;
    handleCloseModal: () => void;
}

const CategorizeModal = ({
    openModal,
    type,
    username,
    handleCloseModal,
}: ICategorizeModal) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [response, setResponse] = useState<any>();
    const [generalError, setGeneralError] = useState<string>();
    const [dateFilters, setDateFilters] = useState<any>();

    const onCloseModal = () => {
        handleCloseModal();
        setLoading(false)
        setGeneralError(undefined)
        setDateFilters(undefined)
        setResponse(undefined)
    }

    const onClickCategorize = async () => {
        setLoading(true)
        setGeneralError(undefined)
        try {
            let formData: any = {
                username: username
            }
            if (dateFilters) {
                formData = {
                    ...formData || {},
                    dueDateRange: dateFilters
                }
            }
            if (type === 'payable') {
                const res: any = await dispatch(tryToCategorizePayableInvoices(formData)).unwrap()
                setResponse(res?.data)
            } else {
                const res: any = await dispatch(tryToCategorizeReceivableInvoices(formData)).unwrap()
                setResponse(res?.data)
            }
        } catch (err) {
            setGeneralError(`${err}`)
        }
        setLoading(false)
    }

    const onChangeSelectedFilter = (e: any, type: string) => {
        setDateFilters((prevFilters: any) => ({
            ...prevFilters,
            [type]: e || undefined
        }))
    }

    return (
        <Modal
            open={openModal}
            showInRight
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[95vw] md:min-w-[600px]'}>
                <p className='mb-4 font-semibold text-sm'>Categorize {type === 'payable' ? 'Payable' : 'Receivable'} Invoices</p>
                {generalError && <Error text={generalError} />}
                <div className='bg-[#e4ede657] rounded-[6px] p-3 my-9'>
                    {!response ?
                        <div>
                            <p className='text-primary-light font-bold text-sm mt-2 mb-4'>Categorize by dates:</p>
                            <div className='mb-6 grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-2 lg:gap-4'>
                                <Datepicker
                                    placeholder='From'
                                    containerStyle='mb-0'
                                    inputValue={dateFilters?.from}
                                    onChangeInput={onChangeSelectedFilter}
                                    inputUniqueName={'from'}
                                />
                                <Datepicker
                                    placeholder='To'
                                    containerStyle='mb-0'
                                    inputValue={dateFilters?.to}
                                    onChangeInput={onChangeSelectedFilter}
                                    inputUniqueName={'to'}
                                />
                            </div>
                        </div>
                        : <div className='my-3'>
                            <p><span className='font-bold mr-1 mb-2'>Total Due Invoices:</span>{response?.totalDueInvoices}</p>
                            <p><span className='font-bold mr-1 mb-2'>Total Paid Invoices:</span>{response?.totalPaidInvoices}</p>
                            <p><span className='font-bold mr-1 mb-2'>Total Over Due Invoices</span>{response?.totalOverDueInvoices}</p>
                        </div>
                    }
                </div>
                <div className='min-w-[100%] flex flex-row justify-center'>
                    <Button
                        label={'Close'}
                        className={'btn-primary-rounded-less min-w-[130px] mr-2 !shadow-none'}
                        onClickButton={onCloseModal}
                    />
                    {!response &&
                        <Button
                            label={'Categorize Invoices'}
                            icon={<img alt="reviewt" className="mr-2 w-5 object-contain" src="/assets/shared/reviewt.svg" />}
                            className={`btn-primary-rounded-less mr-2 flex flex-row ${loading ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            secondLoading={loading}
                            onClickButton={() => !loading && onClickCategorize()}
                        />
                    }
                </div>
            </div>
        </Modal>
    )
}
export default CategorizeModal;